import styled from "styled-components";

const FilterHeader = styled.div`
    > .inner {
        background-color: #efefef;
        padding: 15px;
        .icon {
            font-size: 18px;
        }
    }
    &.active {
        > .inner {
            background-color: #ddd;
        }
    }
`;

export default FilterHeader;
